import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUIPlus from "view-ui-plus"
import "view-ui-plus/dist/styles/viewuiplus.css"    
import BaiduMap from 'vue-baidu-map-3x'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
//import 'vue-baidu-map-3x/dist/style.css'
import '@/assets/styles.css'


    window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = true


    const vue= createApp(App)
    vue.use(store)
    vue.use(router)
    vue.use(ViewUIPlus)
    vue.use(BaiduMap,{
        ak:'9NuqXaZRT8lGb3wJXMgauM6FAHUdFQ9g',
        //v:'2.0',        // 默认使用3.0
        //type:'WebGL'    // ||API 默认API  (使用此模式 BMap=BMapGL)
    })
    vue.mount('#app')

    /*
    window.onerror=function (message,source,lineno,colno,error){

        return true;//阻止浏览器默认的错误提示框
    }
        */